import React from "react";
import { Column } from "@origin-digital/ods-core";
import { useNavigation } from "@origin-digital/navigation-client-sdk";
import { NavLink } from "../NavLink";

export const DesktopNav = () => {
  const { data, loading } = useNavigation();
  const navData = data?.children;
  if (loading) {
    return null;
  }
  return (
    <>
      {navData?.map((navLink) => (
        <Column key={navLink.name} width="content">
          <NavLink key={navLink.name} linkConfig={navLink} headlineLink />
        </Column>
      ))}
    </>
  );
};
